export const CALENDARS = 'calendars'
export const CALENDAR_SETTINGS = 'calendar_settings'
export const JP_DATES = ['日', '月', '火', '水', '木', '金', '土']

export const COLLECTION_SITE_CALENDARS = 'collection_site_calendars'
